import { OnDestroy, OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { LayoutService } from './service/app.layout.service';
import { AccountService, NotificationDto } from '../proxy/account';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Pagination } from '../shared/models/pagination.model';
import { Router } from '@angular/router';
import { ReloadService } from '../shared/services/reload.service';

@Component({
    selector: 'app-notification',
    templateUrl: './app.notification.component.html',
    styleUrls: ['./app.notification.component.scss'],
})
export class AppNotificationComponent implements OnInit, OnDestroy {
    //System variables
    private ngUnsubscribe = new Subject<void>();

    //Paging variables
    public page: number = 1;
    public per_page: number = 100;
    public total: number = 0;

    //Business variables
    public latestNotification: NotificationDto[];
    public allNotification: NotificationDto[];
    public unreadCount = 0;

    constructor(
        public layoutService: LayoutService,
        private accountService: AccountService,
        private routerService: Router,
        private reloadService: ReloadService,
    ) {}

    ngOnDestroy(): void {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

    ngOnInit() {
        this.loadData();
        this.reloadService.reload$.subscribe(() => {
            this.loadData();
        });
    }

    private loadData() {
        this.accountService
            .getNotification(this.page, this.per_page)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe({
                next: (response: Pagination<NotificationDto>) => {
                    this.allNotification = response.data;
                    this.total = response.pagination.total;
                    this.unreadCount = this.allNotification.filter(
                        (x) => x.status == 0,
                    ).length;
                    this.latestNotification = this.allNotification.slice(0, 12);
                },
                error: (ex) => {
                    const errorCode = ex.error.errorCode;
                },
            });
    }

    public makeReadAll() {
        this.accountService
            .makeReadAllNotification()
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe({
                next: (response: any) => {},
                error: (ex) => {
                    const errorCode = ex.error.errorCode;
                },
            });
        this.loadData();
    }

    public makeRead(id: number) {
        this.accountService
            .makeReadNotification(id)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe({
                next: (response: any) => {},
                error: (ex) => {
                    const errorCode = ex.error.errorCode;
                },
            });
        this.loadData();
    }

    public viewBookingDetail(notificationId: number, bookingId: number) {
        this.makeRead(notificationId);
        this.routerService.navigateByUrl('/trip/trip-detail/' + bookingId);
    }
}
